import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const StyledLink = styled.a<any>`
  display: flex;
  cursor: pointer;
`;

export const SmallIconWrapper = styled(FlexRow)<{
  logoColor: string;
}>`
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  box-shadow: ${themeStyle.varShadowMedium};
  background-color: ${({ logoColor }) =>
    logoColor ? logoColor : 'transparent'};
`;
